/* Veltron - lightbox das fotos de review (galeria + cards). Carregado por templates/product.002.json */
(function(){
  var LB=(function(){
    var lb,stage,img,bPrev,bNext,cnt,list=[],idx=0,s=1,tx=0,ty=0,
        pts={},pinchD=0,pinchS=1,moved=false,downOnImg=false,lastFocus=null;
    function dist(a,b){var dx=a.x-b.x,dy=a.y-b.y;return Math.sqrt(dx*dx+dy*dy);}
    function apply(){
      img.style.transform='translate('+tx+'px,'+ty+'px) scale('+s+')';
      if(s>1){lb.classList.add('vr-lb-z');}else{lb.classList.remove('vr-lb-z');}
    }
    function reset(){s=1;tx=0;ty=0;apply();}
    function clamp(){
      var st=stage.getBoundingClientRect(),
          mx=Math.max(0,(img.offsetWidth*s-st.width)/2),
          my=Math.max(0,(img.offsetHeight*s-st.height)/2);
      tx=Math.min(mx,Math.max(-mx,tx));ty=Math.min(my,Math.max(-my,ty));
    }
    function zoomAt(ns,cx,cy){
      var st=stage.getBoundingClientRect(),
          px=cx-st.left-st.width/2,py=cy-st.top-st.height/2;
      ns=Math.min(5,Math.max(1,ns));
      tx=px-(ns/s)*(px-tx);ty=py-(ns/s)*(py-ty);s=ns;
      if(s<=1.001){s=1;tx=0;ty=0;}else{clamp();}
      apply();
    }
    function onWheel(ev){ev.preventDefault();zoomAt(s*Math.exp(-ev.deltaY*0.0022),ev.clientX,ev.clientY);}
    function onDown(ev){
      downOnImg=(ev.target===img);
      if(!downOnImg&&s<=1)return;
      pts[ev.pointerId]={x:ev.clientX,y:ev.clientY};moved=false;
      var k=Object.keys(pts);
      if(k.length===2){pinchD=dist(pts[k[0]],pts[k[1]]);pinchS=s;}
      if(s>1)lb.classList.add('vr-lb-drag');
    }
    function onMove(ev){
      if(!pts[ev.pointerId])return;
      var prev=pts[ev.pointerId];pts[ev.pointerId]={x:ev.clientX,y:ev.clientY};
      var k=Object.keys(pts);
      if(k.length===2){
        if(pinchD>0){
          moved=true;
          var d=dist(pts[k[0]],pts[k[1]]),
              mx=(pts[k[0]].x+pts[k[1]].x)/2,my=(pts[k[0]].y+pts[k[1]].y)/2;
          zoomAt(pinchS*(d/pinchD),mx,my);
        }
        return;
      }
      if(s>1){
        var dx=ev.clientX-prev.x,dy=ev.clientY-prev.y;
        if(Math.abs(dx)+Math.abs(dy)>2)moved=true;
        tx+=dx;ty+=dy;clamp();apply();ev.preventDefault();
      }
    }
    function onUp(ev){
      delete pts[ev.pointerId];
      if(Object.keys(pts).length<2)pinchD=0;
      lb.classList.remove('vr-lb-drag');
      setTimeout(function(){moved=false;},0);
    }
    function onKey(ev){
      if(!lb||lb.className.indexOf('vr-lb-on')<0)return;
      if(ev.key==='Escape'){close();}
      else if(ev.key==='ArrowLeft'){go(-1);}
      else if(ev.key==='ArrowRight'){go(1);}
      else if(ev.key==='+'||ev.key==='='){zoomAt(s*1.3,window.innerWidth/2,window.innerHeight/2);}
      else if(ev.key==='-'){zoomAt(s/1.3,window.innerWidth/2,window.innerHeight/2);}
    }
    function build(){
      lb=document.createElement('div');lb.className='vr-lb';
      lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
      lb.setAttribute('aria-label','Customer photo');
      lb.innerHTML='<div class="vr-lb-stage"><img class="vr-lb-img" alt="Customer photo" draggable="false"></div>'
        +'<button type="button" class="vr-lb-btn vr-lb-x" aria-label="Close">×</button>'
        +'<button type="button" class="vr-lb-btn vr-lb-nav vr-lb-prev" aria-label="Previous photo">‹</button>'
        +'<button type="button" class="vr-lb-btn vr-lb-nav vr-lb-next" aria-label="Next photo">›</button>'
        +'<div class="vr-lb-bar"><b></b><span>Click, scroll or pinch to zoom</span></div>';
      document.body.appendChild(lb);
      stage=lb.querySelector('.vr-lb-stage');img=lb.querySelector('.vr-lb-img');
      bPrev=lb.querySelector('.vr-lb-prev');bNext=lb.querySelector('.vr-lb-next');
      cnt=lb.querySelector('.vr-lb-bar b');
      lb.querySelector('.vr-lb-x').addEventListener('click',close);
      bPrev.addEventListener('click',function(){go(-1);});
      bNext.addEventListener('click',function(){go(1);});
      stage.addEventListener('click',function(ev){
        if(ev.target===img||downOnImg){if(!moved)zoomAt(s>1?1:2.6,ev.clientX,ev.clientY);}
        else{close();}
      });
      stage.addEventListener('wheel',onWheel,{passive:false});
      stage.addEventListener('pointerdown',onDown);
      stage.addEventListener('pointermove',onMove);
      window.addEventListener('pointerup',onUp);
      window.addEventListener('pointercancel',onUp);
      document.addEventListener('keydown',onKey);
    }
    function show(){
      var it=list[idx],want=idx;
      reset();
      img.src=it.thumb||it.full;
      var hi=new Image();
      hi.onload=function(){if(want===idx&&lb.className.indexOf('vr-lb-on')>=0)img.src=hi.src;};
      hi.src=it.full+'?width=1800';
      cnt.textContent=list.length>1?(idx+1)+' / '+list.length:'';
      bPrev.hidden=bNext.hidden=list.length<2;
    }
    function go(d){if(list.length<2)return;idx=(idx+d+list.length)%list.length;show();}
    function open(items,start){
      if(!lb)build();
      list=items;idx=start||0;lastFocus=document.activeElement;
      document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
      lb.classList.add('vr-lb-on');show();
      lb.querySelector('.vr-lb-x').focus();
    }
    function close(){
      lb.classList.remove('vr-lb-on');
      document.documentElement.style.overflow='';document.body.style.overflow='';
      reset();img.removeAttribute('src');
      if(lastFocus&&lastFocus.focus)lastFocus.focus();
    }
    return {open:open};
  })();

  document.addEventListener('click',function(ev){
    var a=ev.target&&ev.target.closest?ev.target.closest('.vr-gal a,.vr-ph a'):null;
    if(!a||!a.getAttribute('data-full'))return;
    ev.preventDefault();
    var as=a.parentNode.querySelectorAll('a[data-full]'),items=[],start=0;
    for(var j=0;j<as.length;j++){
      items.push({full:as[j].getAttribute('data-full'),thumb:as[j].getAttribute('data-thumb')});
      if(as[j]===a)start=j;
    }
    LB.open(items,start);
  });
})();
